/**
 * Terms of Service Page
 *
 * Simplified for UK law and verification tool context.
 * Focus on practical terms rather than elaborate legal boilerplate.
 */

export const Terms = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1rem' }}>
      <h1 style={{ color: '#2c3e50', marginBottom: '1.5rem' }}>Terms of Service</h1>

      <p style={{ color: '#7f8c8d', marginBottom: '2rem' }}>Last Updated: February 2026</p>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: '#34495e' }}>What This Service Does</h2>
        <p style={{ lineHeight: 1.7, color: '#555' }}>
          This is an AI-assisted verification tool that helps you check whether source materials
          support specific claims. You provide the claims and sources; we analyse whether the
          sources contain evidence supporting or contradicting those claims.
        </p>
        <p style={{ lineHeight: 1.7, color: '#555', marginTop: '1rem' }}>
          This tool does not determine objective truth. It analyses source-claim alignment based on
          the materials you provide.
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: '#34495e' }}>AI Involvement</h2>
        <p style={{ lineHeight: 1.7, color: '#555' }}>
          This service uses artificial intelligence to analyse claims against source materials. AI
          systems can make mistakes - they may misread sources, miss context, or produce inaccurate
          results. You should:
        </p>
        <ul style={{ lineHeight: 1.8, color: '#555', paddingLeft: '1.5rem' }}>
          <li>Review AI assessments before relying on them</li>
          <li>Use the human validation feature to confirm or correct results</li>
          <li>Independently verify important claims</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: '#34495e' }}>Your Responsibilities</h2>
        <ul style={{ lineHeight: 1.8, color: '#555', paddingLeft: '1.5rem' }}>
          <li>You are responsible for the content you submit (claims, sources, documents)</li>
          <li>You must have the right to submit any content you provide</li>
          <li>You are responsible for how you use and share the results</li>
          <li>API and MCP access should respect reasonable rate limits</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: '#34495e' }}>Accuracy and Limitations</h2>
        <p style={{ lineHeight: 1.7, color: '#555' }}>
          We provide this service in good faith but cannot guarantee accuracy. The service may be
          unavailable at times and results may contain errors. We recommend human review for any
          high-stakes decisions.
        </p>
        <p style={{ lineHeight: 1.7, color: '#555', marginTop: '1rem' }}>
          We are not liable for decisions you make based on the service&apos;s output, except where
          liability cannot be excluded by law (such as for fraud or negligence causing personal
          injury).
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: '#34495e' }}>Your Data</h2>
        <p style={{ lineHeight: 1.7, color: '#555' }}>
          To verify claims, we send the content you submit to third-party AI providers for analysis.
          We also log AI interactions to monitor quality and debug issues. We store verification
          results to provide the service and allow you to access your history.
        </p>
        <p style={{ lineHeight: 1.7, color: '#555', marginTop: '1rem' }}>
          We do not use your content to train AI models and we do not sell your data. You can
          request deletion of your data by contacting us.
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ color: '#34495e' }}>Changes to Terms</h2>
        <p style={{ lineHeight: 1.7, color: '#555' }}>
          We may update these terms from time to time. Continued use of the service after changes
          constitutes acceptance of the updated terms.
        </p>
      </section>

      <section>
        <h2 style={{ color: '#34495e' }}>Governing Law</h2>
        <p style={{ lineHeight: 1.7, color: '#555' }}>
          These terms are governed by the laws of England and Wales. Any disputes will be subject to
          the exclusive jurisdiction of the courts of England and Wales.
        </p>
      </section>

      <footer style={{ marginTop: '3rem', paddingTop: '1rem', borderTop: '1px solid #dee2e6' }}>
        <p style={{ color: '#7f8c8d', fontSize: '0.9rem' }}>
          Questions? Contact us at info@scientistintheloop.com
        </p>
      </footer>
    </div>
  )
}
